import { actionTypeConstants } from "../utils";
function customerReducer(state = {}, action = {} as any) {

  switch (action.type) {
    case actionTypeConstants.UPDATE_CUSTOMER_INFO:
      return {
        ...state,
        ...action.payload
      };
    case actionTypeConstants.UPDATE_BOL_DETAILS:
      return {
        ...state,
        bolDetails: action.payload
      };
    case actionTypeConstants.UPDATE_ACCEPT_PAYMENT_DETAILS:
      return {
        ...state,
        acceptPayment: action.payload
      };
      case actionTypeConstants.UPDATE_VALUATION_DETAILS:
      return {
        ...state,
        valuationDetails: action.payload
      }; 
      case actionTypeConstants.UPDATE_VALUATION_DECLARATION:
      return {
        ...state,
        valuationDeclaration: action.payload
      }; 
    default:
      return state;
  }
}

export default customerReducer;
